import React, { useState } from "react";
import { clientService, Client } from "../services/client.service";
import { useToast } from "../context/ToastContext";
import "../styles/clients.css";

interface Props {
    client: Client;
    onClose: () => void;
    onDeleted: () => void;
}

export default function DeleteClientModal({ client, onClose, onDeleted }: Props) {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleDelete = async () => {
        setError("");
        setLoading(true);

        try {
            await clientService.delete(client.id);
            showToast("Client deleted successfully.");
            onDeleted();
        } catch (err: any) {
            setError(err.response?.data?.msg || "Failed to delete client.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-card" onClick={(e) => e.stopPropagation()}>
                <h2>Delete Client</h2>
                <p className="modal-subtitle">This action cannot be undone</p>

                {error && <div className="modal-error">{error}</div>}

                <div className="delete-warning">
                    Are you sure you want to delete <strong>{client.name}</strong>?
                    This will also remove all associated sessions and knowledge.
                </div>

                <div className="modal-actions">
                    <button type="button" className="btn-modal-cancel" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="btn-modal-danger"
                        onClick={handleDelete}
                        disabled={loading}
                    >
                        {loading ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </div>
    );
}
